let ENV_DEV = 'dev';
let ENV_STAGING = 'staging';
let ENV_PRODUCTION = 'production';

export default class Environment {

  static getEnvironment() {
    let env = ENV_PRODUCTION;
    let hostname = window.location.hostname.split('.')[0];

    switch (hostname) {
      case 'wac':
      case 'qa-wac':
      case 'author':
        env = ENV_STAGING;
        break;
      case 'localhost':
        env = ENV_DEV;
        break;
      default:
        env = ENV_PRODUCTION;
    }
    return env;
  }

  static production() {
    return ENV_PRODUCTION;
  }

  static staging() {
    return ENV_STAGING;
  }

  static dev() {
    return ENV_DEV;
  }
}
